module.exports = __webpack_public_path__ + "static/media/stand_4.f75cd687.png";